import $ from 'jquery';
import { InventorySearchEvents } from '@dealersites/inventory/events';
import { isOdd } from '../utilities.js';

function initComparable() {
  // checkbox change
  $('.comparable-check').on('change', function () {
    comparableCheck();
    comparableFormat();
  });

  // comparable hover
  $('.comparable')
    .on('mouseover', function () {
      const group = $(this).data('comparable');
      $(`.${group}`).each(function () {
        $(this).addClass('bg-slate-50');
      });
    })
    .on('mouseout', function () {
      const group = $(this).data('comparable');
      $(`.${group}`).each(function () {
        $(this).removeClass('bg-slate-50');
      });
    });

  comparableCheck();
  comparableFormat();
}

function comparableCheck() {
  $('.comparable-check').each(function () {
    let comparable = $(this).data('comparable');
    if ($(this).prop('checked')) {
      $(`.${comparable}`).removeClass('hidden');
    } else {
      $(`.${comparable}`).addClass('hidden');
    }
  });
}

function comparableFormat() {
  $('.vehicle-garage-card').each(function () {
    $(this)
      .find('.comparable:not(.hidden)')
      .each(function (i) {
        if (isOdd(i)) {
          $(this).find('.compare-info').addClass('text-ford-dark');
          $(this).find('.compare-info').removeClass('text-ford');
        } else {
          $(this).find('.compare-info').addClass('text-ford');
          $(this).find('.compare-info').removeClass('text-ford-dark');
        }
      });
  });
}

$(document).on(InventorySearchEvents.POST_RENDER, () => {
  initComparable();
});

initComparable();
